export const visibilityRules = [
  {
    id: 1,
    hiddenFeatures: [4, 25, 26],
  },

  {
    id: 2,
    hiddenFeatures: [
      2, 3, 4, 5, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
      25, 26,
    ],
  },

  {
    id: 3,
    hiddenFeatures: [],
  },

  {
    id: 4,
    hiddenFeatures: [],
  },
];